import React from "react";
import { useTranslation } from 'react-i18next';

const Content = ({ lang, textoprotocolos }) => {

    const { t } = useTranslation();

    return (
        <div id="Content">
            <div className="clearfix content_wrapper">
                <div className="sections_group">
                    <div className="entry-content">

                        <div className="section" style={{ paddingTop: "60px" }}>
                            <div className="clearfix section_wrapper">
                                <div className="clearfix column_attr align_center">
                                    <h6 className="landing4-heading grey" style={{ paddingBottom: "3px", borderBottom: "1px solid #E87C0C", display: "inline-block", borderColor: "#E87C0C" }}>{t("POLÍTICA DE REDES SOCIALES")}</h6>
                                    <hr className="no_line" style={{ margin: "0 auto 15px auto" }} />
                                </div>
                                <div className="column one column_blog">
                                    <div className="clearfix column_attr">
                                        <div className="mb-5 noticia-individual-descripcio-llarga">
                                            <div className="mb-5 noticia-individual-descripcio-llarga" dangerouslySetInnerHTML={{ __html: textoprotocolos.ladesc }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Content;
